<div class="option-buttons row">
  <span
    *ngFor="let option of options"
    class="button button-large"
    [ngClass]="option === selectedOption ? 'active' : ''"
    [innerHTML]="option"
    (click)="selectOption(option)"
  ></span>
</div>
